import { render, staticRenderFns } from "./AdiQuestionarioSituazioneCognitivaComponent.vue?vue&type=template&id=42c72494"
import script from "./AdiQuestionarioSituazioneCognitivaComponent.vue?vue&type=script&lang=js"
export * from "./AdiQuestionarioSituazioneCognitivaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports